<template>
    <CCard class="order-fd-card">
        <CCardHeader>
            <strong>Учет опозданий</strong>
        </CCardHeader>
        <CCardBody>
            <CForm>
                <div class='font-bold mb-3'>Вина Партнера</div>
                <template v-for="(item, index) in DelaysAccounting.partner">
                    <CRow :key="`DelaysAccounting-partner-${index}`" form class="form-group">
                        <CCol style="display: flex; align-items: center;">
                            <input v-model="order.delays_accounting" :value="item" type="checkbox" />
                            <span class="ml-2">{{ item }}</span>
                        </CCol>
                    </CRow>
                </template>
                
                <div class='font-bold mt-4 mb-3'>Вина Мир Сити</div>
                <template v-for="(item, index) in DelaysAccounting.mir_city">
                    <CRow :key="`DelaysAccounting-mir_city-${index}`" form class="form-group">
                        <CCol style="display: flex; align-items: center;">
                            <input v-model="order.delays_accounting" :value="item" type="checkbox" />
                            <span class="ml-2">{{ item }}</span>
                        </CCol>
                    </CRow>
                </template>

                <div class='font-bold mt-4 mb-3'>Форс-мажоры</div>
                <template v-for="(item, index) in DelaysAccounting.force_majeure">
                    <CRow :key="`DelaysAccounting-force_majeure-${index}`" form class="form-group">
                        <CCol style="display: flex; align-items: center;">
                            <input v-model="order.delays_accounting" :value="item" type="checkbox" />
                            <span class="ml-2">{{ item }}</span>
                        </CCol>
                    </CRow>
                </template>

                <!-- <CRow form class="form-group">
                    <CCol style="display: flex; align-items: center;">
                        <input v-model="other.enabled" type="checkbox" />
                        <span class="ml-2">Другое поручение</span>
                    </CCol>
                </CRow>
                <CRow form class="form-group" v-if="other.enabled">
                    <CInput
                        v-model="other.data"
                        placeholder="Опишите поручение"
                    />
                </CRow> -->
            </CForm>
        </CCardBody>
        <CCardFooter>
            <CButton
                color="primary"
                class="mr-3"
                @click="update"
            >Сохранить</CButton
            >
        </CCardFooter>
    </CCard>
</template>

<script>
    export default {
        name: 'OrderDelaysAccounting',

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                DelaysAccounting: {
                    partner: [
                        'Заказ не готов к оговоренному сроку (на основании данных от ресторана)',
                        'Ошибки в составе заказа (не положили позицию или положили не правильную)',
                        'Отказ от заказа после подтверждения.  (не смогут приготовить)',
                        'Не правильная смена статуса (статус готов – фактически не готов)',
                        'Не своевременное внесение блюда в стоп лист'
                    ],
                    mir_city: [
                        'Технические сбои в приложении',
                        'Ошибки курьеров (проблемы с логистикой)',
                        'Несвоевременный забор заказа (более 10 минут)',
                        'Неверные данные в системе (остался не актуальный комментарий пользователя)'
                    ],
                    force_majeure: [
                        'Клиент не сделал заявку на пропуск',
                        'Клиент перестал выходить на связь',
                        'Очередь в при получения пропуска',
                        'Технические причины (Не работает лифт, ПО пропускной системы и тд)'
                    ]
                },
                // other: {
                //     enabled: false,
                //     data: ''
                // }
            };
        },

        computed: {
            adminOnly() {
                return JSON.parse(localStorage.getItem('settings'))?.is_business_admin;
            },
        },

        // watch: {
        //     order: async function(val) {
        //         if(this.order.ed && this.order.ed.items[0].entity && this.order.ed.items[0].entity.entityType && this.order.ed.items[0].entity.entityType.delays_accounting) {
        //             this.haveDelaysAccounting = true;
        //             this.DelaysAccounting = this.order.ed.items[0].entity.entityType.delays_accounting_values;
        //             if(!this.order.delays_accounting) {
        //                 this.order.delays_accounting = [];
        //             } else {
        //                 const DelaysAccountingValues = this.DelaysAccounting.map(item => item.title);
        //                 for (let index = 0; index < this.order.delays_accounting.length; index ++) {
        //                     const item = this.order.delays_accounting[index];
        //                     if(DelaysAccountingValues.indexOf(item) < 0) {
        //                         this.other.enabled = true;
        //                         this.other.data = item;
        //                         this.order.delays_accounting.splice(index, 1);
        //                         return;
        //                     }
        //                 }
        //             }
        //         }
        //     }
        // },

        async mounted() {
        },

        methods: {
            update() {
                this.order.baseInfoOnly = true;
                // if (this.other.enabled) {
                //     this.order.delays_accounting.push(this.other.data);
                // }
                console.log(this.order.delays_accounting);
                this.$emit('update', this.order);
            }
        },
    };
</script>

<style lang="scss">
.input_field {
    outline: none;
}
.component-cart__promocode {
    z-index: 99;

    &__input {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border: 1px solid #d8dbe0;
        z-index: 99;
        padding: 10px;

        > input:focus-within {
            // border: 1px solid #90949A;
        }
        > input.input-focused {
            border: none;
        }

        &.input.input-focused {
            // border: 1px solid #90949A;
        }
        &.input.input-success {
            border: 1px solid #219653;
        }
        &.input.input-with-errors {
            border: 1px solid #EB5757;
        }
    }
    &__button {
        text-align: right;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: #219653;

        &:disabled {
            color: #C3C8CC;
            opacity: 1;
        }

        &__true {
            color: #738FA1;
            width: auto;
            // width: 16px;
            // height: 16px;
            // background: url('../../static/cart_promocode-true.svg') center center no-repeat;
        }
        &__false {
            width: 16px;
            height: 16px;
        }
    }
    &__description {
        padding-left: 5px;
        // margin-top: -15px;
        margin-bottom: 16px;
        
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        color: #219653;
    }
    &__error {
        padding-left: 5px;
        // margin-top: -15px;
        margin-bottom: 16px;
        
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        color: #EB5757;
    }
}
</style>
